import { render, staticRenderFns } from "./picIndex.vue?vue&type=template&id=4f5caa93&scoped=true&"
import script from "./picIndex.vue?vue&type=script&lang=js&"
export * from "./picIndex.vue?vue&type=script&lang=js&"
import style0 from "./picIndex.vue?vue&type=style&index=0&id=4f5caa93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5caa93",
  null
  
)

export default component.exports